import React, { useMemo } from 'react';

import { Colors } from 'works/legacy/lib/style-helper';
import { Row } from 'antd';

export function RecipientsStatusLine({
  spearfishingNotifications,
}: {
  spearfishingNotifications: { id: string; state: string }[] | undefined;
}) {
  const notifications = spearfishingNotifications?.length || 0;

  const { noResponse, claimed, declined } = useMemo(() => {
    return (spearfishingNotifications || []).reduce(
      (acc, notification) => {
        if (notification.state === 'claimed') {
          acc.claimed += 1;
        } else if (notification.state === 'declined') {
          acc.declined += 1;
        } else {
          acc.noResponse += 1;
        }
        return acc;
      },
      { noResponse: 0, claimed: 0, declined: 0 }
    );
  }, [spearfishingNotifications]);

  const { noResponseSize, claimedSize, declinedSize } = useMemo(() => {
    return {
      noResponseSize: (100 * noResponse) / notifications,
      claimedSize: (100 * claimed) / notifications,
      declinedSize: (100 * declined) / notifications,
    };
  }, [noResponse, notifications, claimed, declined]);

  return (
    <>
      <div className="RecipientsStatusLine">
        <div style={{ marginBottom: 16 }}>Responses</div>
        <Row style={{ borderRadius: 3, overflow: 'hidden', marginBottom: 16 }}>
          <div
            className="Line"
            style={{
              width: `${noResponseSize}%`,
              backgroundColor: Colors.steel,
            }}
          />
          <div
            className="Line"
            style={{
              width: `${declinedSize}%`,
              backgroundColor: Colors.coral,
            }}
          />
          <div
            className="Line"
            style={{
              width: `${claimedSize}%`,
              backgroundColor: Colors.grassMid,
            }}
          />
        </Row>
        <Row>
          <div
            className="Badge"
            style={{
              backgroundColor: Colors.steel,
            }}
          >
            {noResponse} No Response
          </div>
          <div
            className="Badge"
            style={{
              backgroundColor: Colors.coral,
              color: Colors.white,
            }}
          >
            {declined} Declined
          </div>
          <div
            className="Badge"
            style={{
              backgroundColor: Colors.grassMid,
              color: Colors.white,
            }}
          >
            {claimed} Claimed
          </div>
        </Row>
      </div>
      <style jsx>{`
        :global(.RecipientsStatusLine) {
          width: 100%;
          background-color: ${Colors.steelLightest};
          padding: 16px;
          border-radius: 3px;
        }
        :global(.RecipientsStatusLine .Badge) {
          padding-right: 12px;
          padding-left: 12px;
          border-radius: 12px;
          margin-right: 16px;
          font-weight: 500;
        }
        :global(.RecipientsStatusLine .Line) {
          height: 12px;
        }
      `}</style>
    </>
  );
}
